import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=1260ca3e&scoped=true&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"
import style0 from "./Header.vue?vue&type=style&index=0&id=1260ca3e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1260ca3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1260ca3e')) {
      api.createRecord('1260ca3e', component.options)
    } else {
      api.reload('1260ca3e', component.options)
    }
    module.hot.accept("./Header.vue?vue&type=template&id=1260ca3e&scoped=true&", function () {
      api.rerender('1260ca3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/Header/Header.vue"
export default component.exports